import { useEffect, useState } from "react";
import { getLeadInteractions } from "@/services/interactions.service";
import { useSmsRefreshStore } from "@/store/sms/sms-refresh.store";

/** How many texts (both directions) the lead has, for the Messages tab badge. Refreshes on a live messaging event. */
export function useLeadSmsCount(leadId: number, enabled: boolean) {
  const [count, setCount] = useState(0);
  const version = useSmsRefreshStore((s) => s.versionByLead[leadId] ?? 0);

  useEffect(() => {
    if (!enabled || !leadId) return;
    let cancelled = false;
    getLeadInteractions(leadId, 1, 1, "sms")
      .then((response) => !cancelled && setCount(response.totalCount))
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [leadId, version, enabled]);

  return count;
}
